module.exports = __webpack_public_path__ + "static/media/octorion-team-intro.4120f862.svg";